import templateUrl from 'servicestack/auto-query/auto-query-nav-panel.htm'
import AutoQueryConfig from 'servicestack/auto-query/auto-query.config'
import basicController from 'servicestack/basic.controller.properties'

class AutoQueryNavPanelController {
    constructor() {
        basicController(this)
        this.hideEmptyGroupings = AutoQueryConfig.hideEmptyGroupings === true;
        this.hideGroupingCounts = AutoQueryConfig.hideGroupingCounts === true;
        this.maxPanelHeight = AutoQueryConfig.maxPanelHeight;
    }
}

let AutoQueryNavPanelComponent = {
    bindings:{
        title: '@',
        //db: '<ngModel',
        query: '<',
        navs: '<',
        panelType: '@'
    },
    controller : AutoQueryNavPanelController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
}

export default AutoQueryNavPanelComponent;
